import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import Store from "@/state/store";

import { vfmPlugin } from 'vue-final-modal';
import VCalendar from 'v-calendar';
import 'v-calendar/dist/style.css';

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

createApp(App)
  .use(VueViewer)
  .use(router)
  .use(Store)
  .use(vfmPlugin)
  .use(VCalendar, {})
  .mount('#app')